






import LoadingPage from '@/components/LoadingPage.vue';
import { generateLoginToken, isLoginTokenValid } from '@/helpers/login';
import Vue from 'vue';

export default Vue.extend({
  components: {
    LoadingPage,
  },
  data() {
    return {
      isLoading: true,
    };
  },
  computed: {
    name(): string {
      return this.$store.getters.studentFirstName || '';
    },

    email(): string {
      return this.$store.getters.personalData?.email || '';
    },
    isEnrollmentStatusFailure(): boolean {
      return this.$store.getters.enrollmentStatus === '';
    },
  },
  async created(): Promise<void> {
    const token = this.$router.currentRoute.query.token as string;

    if (!token) return this.goToHome();

    const hasEnrollment = await this.$store.dispatch('GET_ENROLLMENT');

    if (!hasEnrollment) return this.goToAdmissions();

    const enrollmentStatus = this.$store.getters.enrollmentStatus as string;

    const isEnrollmentSucceeded = ['success', 'pendingPayment'].includes(enrollmentStatus);

    if (!isEnrollmentSucceeded) return this.goToHome();

    const d = this.$cookies.get('d');

    if (!d) return this.goToAccounts();

    const { email } = this.$store.getters.personalData;

    if (!isLoginTokenValid(token, email)) return this.goToHome();

    await this.$store.dispatch('LOGIN_PLATFORM');

    // wait to ensure hubspot event triggers
    setTimeout(() => this.goToClassrooms(), 2000);
  },
  methods: {
    goToHome(): void {
      window.location.replace('/');
    },
    goToAdmissions(): void {
      const admissionsUrl: string = process.env.VUE_APP_ADMISSIONS_URL || '/';

      window.location.replace(admissionsUrl);
    },
    goToAccounts(): void {
      this.$cookies.remove('d', '/', '.descomplica.com.br');

      const accountsUrl: string = process.env.VUE_APP_ACCOUNTS_URL || '/';
      const baseUrl: string = process.env.BASE_URL || '/';
      const { origin } = window.location;

      const { email } = this.$store.getters.personalData;

      const token = generateLoginToken(email);

      const url = `${accountsUrl}${origin}${baseUrl}validar-login%3Ftoken%3D${token}`;

      window.location.replace(url);
    },
    goToClassrooms(): void {
      const clasroomsUrl: string = process.env.VUE_APP_CLASSROOMS_URL || '/';

      window.location.replace(clasroomsUrl);
    },
  },
});
